/* Battery Online — Shopify commerce layer. Runs after the untouched source script (battery-online.js). */
(function(){
'use strict';
var $$=function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))};
/* FAQ keyboard access (source handles click) */
$$('.faq-q[role=button]').forEach(function(q){q.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();q.click()}})});
/* Stretched links inside draggable rows: ignore the click that ends a drag */
$$('#collSlider,.prod-grid-4').forEach(function(el){var x=0;el.addEventListener('mousedown',function(e){x=e.pageX});
 el.addEventListener('click',function(e){if(Math.abs(e.pageX-x)>6&&e.target.closest('a')){e.preventDefault();e.stopPropagation()}},true)});
/* Vehicle battery finder — dropdown data: car brand/model reference (source: car brand and model.xlsx, embedded as #vehicleModelsData). Actual battery fitment is still verified separately via /?view=fitment on submit, below — unchanged. */
$$('form[data-finder]').forEach(function(f){
 var results=document.getElementById('finderResults'),mapEl=document.getElementById('vehicleModelsData'),modelSel=f.querySelector('[data-model-select]');
 var modelsByMake={};try{modelsByMake=JSON.parse(mapEl.textContent)||{}}catch(e){}
 function sync(inp){var box=inp.closest('.finder-select'),lbl=box.querySelector('[data-label]');
  if(!box.dataset.c)box.dataset.c=box.style.color||'-';var o=box.dataset.c==='-'?'':box.dataset.c;
  lbl.textContent=inp.value||inp.options[0].text;box.style.color=(inp.name==='year'&&!inp.value)?o:(inp.value?'var(--ink)':o)}
 function fillModels(make,keep){var ms=(modelsByMake[make]||[]).slice();
  modelSel.innerHTML='';
  if(!ms.length){modelSel.innerHTML='<option value="">No listed models</option>';}
  else{modelSel.innerHTML='<option value="">Model</option>'+ms.map(function(m){return '<option'+(m===keep?' selected':'')+'>'+esc(m)+'</option>'}).join('')}
  sync(modelSel)}
 var esc=function(s){var d=document.createElement('div');d.textContent=s==null?'':s;return d.innerHTML};
 var makeSel=f.querySelector('select[name=make]');
 fillModels(makeSel.value,'Land Cruiser');
 $$('.finder-native',f).forEach(function(inp){inp.addEventListener('change',function(){sync(inp);if(inp===makeSel)fillModels(inp.value)})});
 var cache=null;
 function load(){if(cache)return Promise.resolve(cache);var url=f.dataset.fitmentUrl,all=[];
  function page(u){return fetch(u,{headers:{Accept:'application/json'}}).then(function(r){return r.json()}).then(function(j){all=all.concat(j.vehicles||[]);return j.next?page(j.next+(j.next.indexOf('view=')<0?'&view=fitment':'')):all})}
  return page(url).then(function(v){cache=v;return v})}
 function money(c){var n=c/100;return 'AED '+(n%1?n.toLocaleString('en-US',{minimumFractionDigits:2}):n.toLocaleString('en-US'))}
 function card(b,o){var sold=!b.available;
  return '<div class="pc"><div class="pc-img">'+(b.image?'<img class="pc-photo" src="'+esc(b.image)+'" alt="'+esc(b.title)+'" loading="lazy">':'')
   +(o.type?'<span class="pc-badge pc-badge-blue">'+esc(o.type)+'</span>':'')+'<a class="pc-link" href="'+esc(b.url)+'" aria-label="'+esc(b.title)+'"></a></div>'
   +'<div class="pc-body"><div class="pc-brand">'+esc(b.vendor)+'</div><div class="pc-name"><a href="'+esc(b.url)+'" style="color:inherit">'+esc(b.title)+(b.variant?' — '+esc(b.variant):'')+'</a></div>'
   +'<div class="pc-specs">'+(o.ah?'<span class="spec">'+esc(o.ah)+'Ah</span>':'')+(o.type?'<span class="spec">'+esc(o.type)+'</span>':'')+'</div>'
   +'<div class="pc-price"><strong>'+money(b.price)+'</strong></div><div class="pc-fit">Fitted &amp; registered at your location</div>'
   +'<div class="pc-btn-row"><form action="'+window.routes.cart_add_url+'" method="post" data-ajax-cart style="display:contents"><input type="hidden" name="id" value="'+b.id+'"><input type="hidden" name="quantity" value="1"><button class="pc-btn" type="submit"'+(sold?' disabled':'')+'>'+(sold?'Sold Out':'Add to Cart')+'</button></form>'
   +'<a class="pc-call" href="'+f.dataset.tel+'" aria-label="Call to confirm">📞</a></div></div></div>'}
 function show(html){results.innerHTML='<div class="inner fr-inner">'+html+'</div>';results.hidden=false;results.scrollIntoView({behavior:'smooth',block:'nearest'})}
 function noMatch(car){var msg='Hi Battery Online, please confirm the correct battery for my '+car;
  return '<div class="fr-empty"><p>No exact battery match has been added for this vehicle yet. Contact us and our team will confirm the correct battery.</p>'
   +'<div class="fr-cta"><a class="btn btn-dark" href="'+f.dataset.wa+'?text='+encodeURIComponent(msg)+'" target="_blank" rel="noopener">WhatsApp a Specialist</a><a class="btn btn-outline-dark" href="'+f.dataset.tel+'">📞 Call Us</a></div></div>'}
 var demoMode=/[?&]fitment_demo=1(&|$)/.test(location.search);
 function normKey(s){return (s||'').toString().trim().toLowerCase()}
 /* Make aliases: dropdown options that intentionally re-use another make's
    verified fitment data rather than duplicating it (documented in
    snippets/vehicle-models-data.liquid for the model-list side of this same
    alias). "Toyota Land Cruiser" is a separate dropdown/model-list entry for
    discoverability, but its real fitment data lives under make="Toyota"
    (which already includes Land Cruiser/Land Cruiser Prado-specific
    vehicle_fitment records) — so it is matched as Toyota here instead of
    being treated as a brand with zero fitment data. The MODEL selected is
    never touched by this alias — it is matched as its own separate key
    (see pickFitment below), so "Toyota Land Cruiser → Camry" and
    "Toyota → Camry" resolve identically, and neither is treated as if the
    user had picked "Land Cruiser". */
 var MAKE_ALIASES={'toyota land cruiser':'toyota'};
 function normMake(s){var k=normKey(s);return MAKE_ALIASES[k]||k}
 function pickFitment(vs,make,model,year){
  var mk=normMake(make),md=normKey(model),cands=[];
  vs.forEach(function(v){
   if(normKey(v.make)!==mk)return;
   var vModel=normKey(v.model),modelExact=(vModel===md),modelWild=(vModel===''||vModel==='all'||vModel==='all models');
   if(!modelExact&&!modelWild)return;
   var from=v.from||0,to=(v.to&&v.to>0)?v.to:9999;
   if(year<from||year>to)return;
   cands.push({v:v,tier:modelExact?1:2,span:to-from});
  });
  cands.sort(function(a,b){return a.tier!==b.tier?a.tier-b.tier:a.span-b.span});
  for(var i=0;i<cands.length;i++){
   var opts=cands[i].v.options.filter(function(o){return o.batteries&&o.batteries.length});
   if(opts.length)return {fit:cands[i].v,opts:opts,tier:cands[i].tier}
  }
  return null}
 function demoBanner(){return demoMode?'<div class="fr-tag" style="background:#ffe9a8;color:#7a5b00;margin-bottom:14px;display:inline-flex">⚠️ DEMO / TEST RESULTS — NOT VERIFIED FITMENT</div>':''}
 /* Hard cap on cards shown per result, regardless of how many a group
    holds: "~5–8 results, never pad to fill" — this only ever trims,
    never adds, so a vehicle with fewer genuinely compatible batteries
    still shows fewer. */
 var MAX_RESULTS=8;
 f.addEventListener('submit',function(e){e.preventDefault();
  var make=makeSel.value,model=modelSel.value,year=parseInt(f.querySelector('select[name=year]').value,10),car=[make,model,year||''].join(' ').trim();
  if(!model||!year){show('<div class="fr-empty"><p>Please select your vehicle’s '+(!model?'model':'year')+'.</p></div>');return}
  show('<p class="fr-note">Checking verified fitment…</p>');
  load().then(function(vs){
   var result=pickFitment(vs,make,model,year);
   if(!result){
    var hh=demoBanner()+'<div class="sec-head fr-head"><h2>Battery Options for '+esc(make)+' · '+esc(model)+' · '+(year||'')+'</h2></div>';
    if(demoMode){
     hh+='<p class="fr-note">No real fitment record matches this selection. Showing one sample product so you can preview the card layout — this is NOT a real compatibility claim.</p>';
     hh+='<div class="prod-grid-4 fr-grid">'+card({id:47670016999580,title:'Bosch AGM DIN80 / 80AH (SAMPLE)',variant:null,vendor:'Bosch',url:'/products/bosch-agm-din80-80ah',image:null,price:120000,available:true},{})+'</div>';
     show(hh);return}
    show(hh+noMatch(car));return}
   var winner=result.fit,opts=result.opts,isBrand=(result.tier===2);
   /* Technician disclaimer must appear FIRST, before the result heading and
      before any battery cards (required placement) — then a single bold
      line "Battery Options for {Make} · {Model} · {Year}", with no
      "Exact" wording and no separate make-only heading + make/model/year
      sub-line (previously two lines; now always one, for both the
      model-specific and brand-fallback cases, built entirely from the
      user's actual selection — never hardcoded). */
   var h=demoBanner();
   h+='<p class="fr-note fr-disclaimer">Final battery fitment should be confirmed by our technician based on your vehicle specifications.</p>';
   h+='<div class="sec-head fr-head"><h2>Battery Options for '+esc(make)+' · '+esc(model)+' · '+year+'</h2></div>';
   h+='<div class="fr-gen">'+(isBrand?'<span class="fr-tag fr-tag-muted">Brand-level battery options</span>':'<span class="fr-tag">Verified vehicle fitment</span>')+(winner.generation?'<span class="fr-tag fr-tag-muted">'+esc(winner.generation)+'</span>':'')+(!isBrand&&winner.confidence?'<span class="fr-tag fr-tag-muted">'+esc(winner.confidence)+'</span>':'')+'</div>';
   if(isBrand){
    var allB=[],seen={};
    opts.forEach(function(o){o.batteries.forEach(function(b){if(!seen[b.id]){seen[b.id]=1;allB.push(b)}})});
    allB=allB.slice(0,MAX_RESULTS);
    h+='<div class="prod-grid-4 fr-grid">'+allB.map(function(b){return card(b,{})}).join('')+'</div>';
   }else{
    if(winner.notes)h+='<p class="fr-note">'+esc(winner.notes)+'</p>';
    opts.forEach(function(o,i){
     h+='<div class="fr-opt">'+(opts.length>1?'<strong>Option '+(i+1)+':</strong> if your current battery is ':'<strong>Required:</strong> ')+esc(o.requirement)+'</div>';
     h+='<div class="prod-grid-4 fr-grid">'+o.batteries.slice(0,MAX_RESULTS).map(function(b){return card(b,o)}).join('')+'</div>'})}
   h+='<p class="fr-foot">Not sure which option you have? <a href="'+f.dataset.wa+'?text='+encodeURIComponent('Hi, please confirm the battery for my '+car)+'" target="_blank" rel="noopener">Send us a photo of your battery label</a> — a technician confirms fitment before installation.</p>';
   show(h)}).catch(function(){show(noMatch(car))})})});
/* Toast + cart count */
var toast;function say(h){if(!toast){toast=document.createElement('div');toast.className='bo-toast';toast.setAttribute('role','status');document.body.appendChild(toast)}
 toast.innerHTML=h;toast.classList.add('show');clearTimeout(toast._t);toast._t=setTimeout(function(){toast.classList.remove('show')},3800)}
function count(){fetch(window.routes.cart_url+'.js').then(function(r){return r.json()}).then(function(c){$$('[data-cart-count]').forEach(function(el){el.textContent=c.item_count;el.hidden=!c.item_count})}).catch(function(){})}
/* ---- Battery Installation add-on ----
   A real, separately priced Shopify service line (fixed AED 100, "Battery
   Installation Service", variant id in data-install-variant-id), added
   alongside the battery with the SAME quantity (the label says "each"), and
   linked to that exact battery line — never a flat/global cart charge —
   via a one-time random pairing token. The token is stored as a cart line
   property on BOTH lines: an underscore-prefixed key (Shopify's documented
   convention for a line property that is hidden from the customer-facing
   cart/checkout/order-notification UI, but still persists in the order's
   real line-item data for staff) so two adds of the same battery — one
   with installation, one without — always get different property sets and
   can never merge into one ambiguous line. The battery line additionally
   gets ONE customer-visible property ("Battery Installation: Included —
   +AED 100 each") so cart/checkout/order both show, in plain language,
   that this specific battery includes installation — no separate custom
   checkout work needed, since Shopify natively carries line properties
   through to the order. */
function genPairToken(){return 'bi'+Date.now().toString(36)+Math.random().toString(36).slice(2,8)}
function addInstallLine(installId,qty,token){
 var fd=new FormData();fd.append('id',installId);fd.append('quantity',qty);
 fd.append('properties[_installation_for]',token);
 return fetch(window.routes.cart_add_url+'.js',{method:'POST',headers:{Accept:'application/json'},body:fd})}
document.addEventListener('submit',function(e){var f=e.target;if(!f.matches||!f.matches('form[data-ajax-cart]'))return;
 e.preventDefault();
 var isBuyNow=!!(e.submitter&&e.submitter.name==='buy_now');
 var root=f.closest('[data-product-form]');
 var cb=root&&root.querySelector('[data-install-addon]');
 var wantsInstall=!!(cb&&cb.checked);
 var installId=root&&root.dataset.installVariantId;
 var qtyInp=root&&root.querySelector('[data-qty]');
 var qty=qtyInp?Math.max(1,parseInt(qtyInp.value,10)||1):1;
 var token=wantsInstall?genPairToken():null;
 var b=e.submitter||f.querySelector('[type=submit]');var t=b&&b.dataset.originalText;
 if(b){if(!t){t=b.textContent;b.dataset.originalText=t}clearTimeout(b._resetT);b.disabled=true;b.textContent=isBuyNow?'Processing…':'Adding…'}
 var fd=new FormData(f);
 if(wantsInstall&&installId){
  fd.append('properties[Battery Installation]','Included — +'+money(10000)+' each');
  fd.append('properties[_install_pair]',token);
 }
 fetch(window.routes.cart_add_url+'.js',{method:'POST',headers:{Accept:'application/json'},body:fd})
 .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j})})
 .then(function(i){
   if(wantsInstall&&installId)return addInstallLine(installId,qty,token).then(function(){return i});
   return i;
 })
 .then(function(i){
   count();
   if(isBuyNow){location.href='/checkout';return}
   say('✓ '+(i.product_title||'Added to cart')+' <a href="'+window.routes.cart_url+'">View cart</a>');
   if(b){b.disabled=false;b.textContent='Added to Cart';b._resetT=setTimeout(function(){b.textContent=t},2200)}
 })
 .catch(function(er){if(!isBuyNow)say((er&&(er.description||er.message))||'Could not add to cart');if(b){b.disabled=false;b.textContent=t}})});
function money(c){return 'AED '+(c/100).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2})}
/* Product page variant picker + live quantity × installation × price (inner template) */
$$('[data-product-form]').forEach(function(root){var dataEl=root.querySelector('script[data-variants]');if(!dataEl)return;var data=JSON.parse(dataEl.textContent),idIn=root.querySelector('input[name=id]'),
price=root.querySelector('[data-price]'),cmp=root.querySelector('[data-compare]'),avail=root.querySelector('[data-avail]'),btns=$$('[data-add]',root),qtyInp=root.querySelector('[data-qty]'),
installCb=root.querySelector('[data-install-addon]'),installRow=root.querySelector('[data-install-row]'),installPriceEl=root.querySelector('[data-install-price]'),totalRow=root.querySelector('[data-total-row]'),totalEl=root.querySelector('[data-total-price]');
var INSTALL_PRICE=parseInt(root.dataset.installUnitPrice,10)||10000;
function currentQty(){var n=qtyInp?parseInt(qtyInp.value,10):1;if(!n||n<1){n=1;if(qtyInp)qtyInp.value=1}return n}
function renderPrice(){
 if(!price)return;
 var unit=parseInt(price.dataset.unitPrice,10)||0,qty=currentQty(),batteryTotal=unit*qty;
 price.textContent=money(batteryTotal);
 var on=!!(installCb&&installCb.checked);
 if(installRow)installRow.hidden=!on;
 if(installPriceEl)installPriceEl.textContent='+'+money(INSTALL_PRICE*qty);
 if(totalRow)totalRow.hidden=!on;
 if(totalEl)totalEl.textContent=money(batteryTotal+(on?INSTALL_PRICE*qty:0));
}
renderPrice();
if(qtyInp)qtyInp.addEventListener('input',renderPrice);
if(installCb)installCb.addEventListener('change',renderPrice);
$$('input[type=radio][data-option]',root).forEach(function(r){r.addEventListener('change',function(){
 var vals=$$('input[type=radio][data-option]:checked',root).map(function(i){return i.value});
 var v=data.find(function(x){return x.options.every(function(o,i){return o===vals[i]})});if(!v)return;
 idIn.value=v.id;if(price){price.dataset.unitPrice=v.price;renderPrice()}if(cmp)cmp.textContent=v.compare_at_price>v.price?money(v.compare_at_price):'';
 if(avail){avail.textContent=v.available?'In stock · fitted at your location':'Sold out';avail.classList.toggle('out',!v.available)}
 btns.forEach(function(b){b.disabled=!v.available});var u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState(null,'',u)})})});
/* Predictive search */
$$('form[data-predictive]').forEach(function(f){var inp=f.querySelector('input[name=q]'),box=f.querySelector('.ps-results'),t,ctl;if(!inp||!box)return;
var close=function(){box.hidden=true;box.innerHTML=''};
f.addEventListener('click',function(e){if(e.target===f)inp.focus()});
inp.addEventListener('input',function(){clearTimeout(t);var q=inp.value.trim();if(q.length<2){close();return}
 t=setTimeout(function(){if(ctl)ctl.abort();ctl=new AbortController();
  fetch(window.routes.predictive_search_url+'.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=6',{signal:ctl.signal}).then(function(r){return r.json()}).then(function(j){
   var ps=(j.resources&&j.resources.results&&j.resources.results.products)||[],esc=function(s){var d=document.createElement('div');d.textContent=s||'';return d.innerHTML};
   box.innerHTML=ps.map(function(p){return '<a href="'+p.url+'">'+(p.image?'<img src="'+p.image+'&width=80" alt="" loading="lazy">':'')+'<span><small>'+esc(p.vendor)+'</small>'+esc(p.title)+'</span></a>'}).join('')+'<a href="'+f.action+'?q='+encodeURIComponent(q)+'&type=product">'+(ps.length?'See all results':'Search all')+' →</a>';box.hidden=false}).catch(function(){})},180)});
inp.addEventListener('keydown',function(e){if(e.key==='Escape')close()});document.addEventListener('click',function(e){if(!f.contains(e.target))close()})});
/* Cart page quantity auto-update */
$$('form[data-cart-form] input[name="updates[]"]').forEach(function(i){i.addEventListener('change',function(){i.form.submit()})});
/* ---- Cart page: pair-aware quantity sync + removal ----
   Each .cart-row carries data-line-index (its position, matching the
   updates[] array order) and data-paired-index (-1 if none — computed
   server-side in main-cart.liquid by matching _install_pair / _installation_for
   properties). Installation rows have a read-only quantity display (no
   stepper) and simply follow their paired battery row, so the two can never
   drift apart; everything still submits through the SAME real Shopify
   /cart update form (updates[] by position) already in main-cart.liquid —
   nothing here computes or displays a total Shopify didn't actually charge. */
(function(){
 var form=document.querySelector('form[data-cart-form]');if(!form)return;
 function rowAt(i){return form.querySelector('.cart-row[data-line-index="'+i+'"]')}
 function inputOf(row){return row&&row.querySelector('[data-qty-input]')}
 function submitCartForm(){
  if(form.requestSubmit){var b=form.querySelector('button[name="update"]');form.requestSubmit(b)}else{form.submit()}
 }
 document.addEventListener('click',function(e){
  var incBtn=e.target.closest('[data-qty-increase]'),decBtn=e.target.closest('[data-qty-decrease]');
  if(incBtn||decBtn){
   var row=(incBtn||decBtn).closest('.cart-row');if(!form.contains(row))return;
   if(row.dataset.isInstall==='true')return; /* installation qty is read-only, follows its battery */
   var input=inputOf(row);var val=parseInt(input.value,10);if(isNaN(val)||val<0)val=0;
   val=incBtn?val+1:Math.max(0,val-1);input.value=val;
   var pairedIdx=row.dataset.pairedIndex;
   if(pairedIdx&&pairedIdx!=='-1'){var pairedInput=inputOf(rowAt(pairedIdx));if(pairedInput)pairedInput.value=val}
   submitCartForm();return;
  }
  var removeLink=e.target.closest('.cart-remove');
  if(removeLink){
   var row2=removeLink.closest('.cart-row');if(!form.contains(row2))return;
   var pairedIdx2=row2.dataset.pairedIndex;
   if(row2.dataset.isInstall!=='true'&&pairedIdx2&&pairedIdx2!=='-1'){
    /* Removing a battery that has installation also removes its paired
       installation line, in the same single cart update — no orphan
       service line left behind. Removing the installation line on its
       own (handled by letting this link fall through untouched below)
       never touches the battery, by design. */
    e.preventDefault();
    var selfInput=inputOf(row2);if(selfInput)selfInput.value=0;
    var pairedInput2=inputOf(rowAt(pairedIdx2));if(pairedInput2)pairedInput2.value=0;
    submitCartForm();
   }
  }
 });
 document.addEventListener('change',function(e){
  if(!e.target.matches('[data-qty-input]'))return;
  var row=e.target.closest('.cart-row');if(row.dataset.isInstall==='true'){submitCartForm();return}
  var val=parseInt(e.target.value,10);if(isNaN(val)||val<0)val=0;e.target.value=val;
  var pairedIdx=row.dataset.pairedIndex;
  if(pairedIdx&&pairedIdx!=='-1'){var pairedInput=inputOf(rowAt(pairedIdx));if(pairedInput)pairedInput.value=val}
  submitCartForm();
 });
})();

/* ---- Shop page client-side filtering: Brand + Availability + Search ----
   Brand/Availability restored after an unrelated earlier edit dropped them
   (see snippets/filters.liquid for that history) — never reloads the page,
   so checkbox state is ordinary DOM state that cannot silently reset, and
   the grid is genuinely filtered, not a visual-only control. Availability
   reflects the stated business rule (every battery here = in stock), never
   real inventory data. Price filtering is untouched native Shopify
   filtering (see snippets/filters.liquid) — a real page reload there is
   expected; all three (brand/availability/search) selections survive that
   reload via sessionStorage, restored and re-applied automatically below.

   SEARCH (added): matches the real catalog, not a hardcoded/demo list. Each
   .cl-item's data-search attribute (set server-side in
   sections/main-collection.liquid from the product's real title, vendor,
   product_type, capacity/battery_type metafields and tags) is reduced to a
   lowercase, alphanumeric-only string, and so is every word the person
   types. A product only has to contain every typed word SOMEWHERE in that
   string (AND, order-independent) to match — so "74AH", "74 AH" and
   "74ah" are equivalent, and "SF SONIC DIN74L" / "Varta DIN70" both narrow
   correctly instead of requiring one exact contiguous phrase. Search runs
   together with brand/availability in the same apply() pass below, so
   combinations like Search=Varta + Brand=Varta + Price range all apply at
   once, and an empty query simply matches everything (no filtering).

   AVAILABILITY SINGLE-SELECT (fix): "In stock" and "Out of stock" must
   never both be active at once. Checking one now always unchecks the
   other — enforced on every change event, and also normalized once on
   restore() in case a session saved a stale both-checked state from
   before this fix. Unchecking the active box still clears the filter back
   to "no availability filter" (shows everything), exactly as before —
   this only removes the both-checked state, nothing else about the
   feature changes. */
(function(){
 var grid=document.getElementById('ClGrid');
 if(!grid)return;

 /* ROOT-CAUSE FIX: this store is on the Basic plan (confirmed), not
    Shopify Plus, so Shopify silently caps every {% paginate %} block at
    50 items per page no matter what "by" value main-collection.liquid
    requests (it asks for "by 250" — only a Plus store actually gets
    that). With 129 real active products in this collection, that real
    50-item ceiling cut off every product past position 50 in the
    collection's current sort order before this script ever saw them —
    9 of this collection's 14 real vendors never reached the DOM at all,
    so no amount of fixing the brand-checkbox list alone could ever make
    their products filterable. data-cl-pages / data-cl-current below are
    set server-side in sections/main-collection.liquid from Shopify's own
    real `paginate` object (itself unaffected by the 50-item product cap).
    Before wiring up the filters, fetch whichever of this same
    collection's OTHER real pages aren't already on the current page
    (preserving every existing query-string parameter — sort_by, the
    native price filter, etc.), and merge their .cl-item nodes into this
    same grid, so brandBoxes/items below always reflect the complete,
    real 129-product set — not just this page's first 50. This never
    changes the real native pagination UI rendered below the grid
    (snippets/pagination.liquid, untouched) — it stays in place as the
    correct fallback if JavaScript is unavailable, or if a future catalog
    genuinely exceeds what can be merged this way. */
 function mergeAllPages(){
  var totalPages=parseInt(grid.dataset.clPages,10)||1;
  var curPage=parseInt(grid.dataset.clCurrent,10)||1;
  if(totalPages<=1||!window.fetch||!window.DOMParser)return Promise.resolve();
  var base=new URL(location.href);
  var jobs=[];
  for(var p=1;p<=totalPages;p++){
   if(p===curPage)continue;
   jobs.push((function(pageNum){
    var u=new URL(base.href);
    u.searchParams.set('page',pageNum);
    return fetch(u.href,{credentials:'same-origin'}).then(function(r){return r.ok?r.text():''}).then(function(html){
     if(!html)return;
     var doc=new DOMParser().parseFromString(html,'text/html');
     var otherGrid=doc.getElementById('ClGrid');
     if(!otherGrid)return;
     $$('.cl-item',otherGrid).forEach(function(node){grid.appendChild(document.importNode(node,true))});
    }).catch(function(){});
   })(p));
  }
  return Promise.all(jobs);
 }

 mergeAllPages().then(init);

 function init(){
 var items=$$('.cl-item',grid);
 var countEl=document.querySelector('[data-cl-count]');
 var emptyEl=document.getElementById('ClEmpty');
 var brandBoxes=$$('[data-cl-brand]');
 var availBoxes=$$('[data-cl-avail]');
 var minInp=document.querySelector('[data-cl-min]');
 var maxInp=document.querySelector('[data-cl-max]');
 var searchInp=document.getElementById('ClSearch');
 var searchClearBtn=document.getElementById('ClSearchClear');
 var STORE_KEY='bo_shop_filters_v1';

 function normalize(s){return (s||'').toLowerCase().replace(/[^a-z0-9]+/g,'')}
 function searchTerms(){
  var raw=(searchInp&&searchInp.value)||'';
  return raw.split(/\s+/).map(normalize).filter(function(t){return t.length>0});
 }

 function currentState(){
  return{
   brands:brandBoxes.filter(function(b){return b.checked}).map(function(b){return b.value}),
   avail:availBoxes.filter(function(b){return b.checked}).map(function(b){return b.value}),
   min:minInp?minInp.value:'',max:maxInp?maxInp.value:'',
   search:searchInp?searchInp.value:''
  };
 }
 function save(){try{sessionStorage.setItem(STORE_KEY,JSON.stringify(currentState()))}catch(e){}}
 function restore(){
  try{
   var s=JSON.parse(sessionStorage.getItem(STORE_KEY));if(!s)return;
   brandBoxes.forEach(function(b){b.checked=!!(s.brands&&s.brands.indexOf(b.value)>-1)});
   availBoxes.forEach(function(b){b.checked=!!(s.avail&&s.avail.indexOf(b.value)>-1)});
   /* Normalize a previously-saved "both checked" availability state (from
      before single-select was enforced) down to just one, keeping the
      first checked box in DOM order ("In stock"). */
   var seenChecked=false;
   availBoxes.forEach(function(b){if(b.checked){if(seenChecked){b.checked=false}else{seenChecked=true}}});
   if(searchInp&&typeof s.search==='string')searchInp.value=s.search;
  }catch(e){}
 }
 function apply(){
  var checkedBrands=brandBoxes.filter(function(b){return b.checked}).map(function(b){return b.value});
  var checkedAvail=availBoxes.filter(function(b){return b.checked}).map(function(b){return b.value});
  var terms=searchTerms();
  if(searchClearBtn)searchClearBtn.hidden=!(searchInp&&searchInp.value);
  var visible=0;
  items.forEach(function(it){
   var vendor=it.dataset.vendor;
   var brandOk=!checkedBrands.length||checkedBrands.indexOf(vendor)>-1;
   var availOk=true;
   if(checkedAvail.length){availOk=checkedAvail.indexOf('in')>-1} /* every real product here is in stock; "out" alone correctly matches nothing */
   var searchOk=true;
   if(terms.length){
    var hay=normalize(it.dataset.search||'');
    searchOk=terms.every(function(t){return hay.indexOf(t)>-1});
   }
   var show=brandOk&&availOk&&searchOk;
   it.style.display=show?'':'none';
   if(show)visible++;
  });
  if(countEl)countEl.textContent=visible;
  if(emptyEl)emptyEl.hidden=visible!==0;
  save();
 }
 restore();apply();
 brandBoxes.forEach(function(b){b.addEventListener('change',apply)});
 availBoxes.forEach(function(b){b.addEventListener('change',function(){
  if(b.checked){availBoxes.forEach(function(o){if(o!==b)o.checked=false})}
  apply();
 })});
 if(searchInp)searchInp.addEventListener('input',apply);
 if(searchClearBtn)searchClearBtn.addEventListener('click',function(){searchInp.value='';apply();searchInp.focus()});
 var applyBtn=document.querySelector('[data-cl-apply]');if(applyBtn)applyBtn.addEventListener('click',apply);
 }
})();

/* ---- Wishlist (client-side, saved in this browser via localStorage) ----
   Stores the product HANDLE (not the numeric id) for each saved battery in
   localStorage (bo_wishlist_v1) — the handle is what lets the dedicated
   wishlist page below re-fetch each product's live data from Shopify's own
   /products/<handle>.js endpoint, so the wishlist always reflects real,
   current price/availability rather than a stale snapshot. Works anywhere
   on the site via one delegated click/keydown listener on [data-wishlist-id]
   — product cards (icon-only ♡/♥), the product-page "Add to Wishlist"
   button (icon + text), and the header counter all share this same single
   source of truth. Reuses the existing say() toast above (shared scope —
   this IIFE sits inside the same top-level closure). */
(function(){
 var KEY='bo_wishlist_v1';
 function load(){try{return JSON.parse(localStorage.getItem(KEY))||[]}catch(e){return []}}
 function persist(list){try{localStorage.setItem(KEY,JSON.stringify(list))}catch(e){}}
 function updateCount(){
  var n=load().length;
  $$('[data-wishlist-count]').forEach(function(el){el.textContent=n;el.hidden=(n===0)});
 }
 /* Two shapes of toggle control share this paint():
    - icon-only (product-card ♡, no children) — the glyph IS the element's
      own text, so it's swapped directly.
    - icon+label (the product-page button, with nested .wl-icon/.wl-text
      spans) — only those children change, so a fixed label like
      "Add to Wishlist" never gets clobbered by the glyph swap. */
 function paint(el,on){
  el.classList.toggle('active',on);
  el.setAttribute('aria-pressed',on?'true':'false');
  var icon=el.querySelector('.wl-icon'),text=el.querySelector('.wl-text');
  if(icon){
   icon.textContent=on?'♥':'♡';
   icon.style.color=on?'#e53e3e':'';
  }else{
   el.textContent=on?'♥':'♡';
   el.style.color=on?'#e53e3e':'';
  }
  if(text)text.textContent=on?(el.dataset.labelOn||'In Wishlist'):(el.dataset.labelOff||'Add to Wishlist');
 }
 function refresh(){
  var list=load();
  $$('[data-wishlist-id]').forEach(function(el){paint(el,list.indexOf(el.dataset.wishlistId)>-1)});
  updateCount();
 }
 refresh();
 document.addEventListener('click',function(e){
  var el=e.target.closest('[data-wishlist-id]');
  if(!el)return;
  e.preventDefault();e.stopPropagation();
  var id=el.dataset.wishlistId,list=load(),idx=list.indexOf(id);
  if(idx>-1){
   list.splice(idx,1);paint(el,false);say('Removed from wishlist');
   /* On the dedicated wishlist page itself, removing a saved battery also
      drops its whole card from the grid right away — not just the heart —
      so the list always matches what's actually saved without a reload. */
   var card=el.closest('[data-wishlist-card]');
   if(card){
    card.remove();
    var grid=document.getElementById('wishlistGrid'),empty=document.getElementById('wishlistEmpty');
    if(grid&&!grid.children.length&&empty)empty.hidden=false;
   }
  }else{
   list.push(id);paint(el,true);say('♥ Added to wishlist');
  }
  persist(list);
  updateCount();
 });
 document.addEventListener('keydown',function(e){
  if(e.key!=='Enter'&&e.key!==' ')return;
  var el=e.target.closest('[data-wishlist-id]');
  if(!el)return;
  e.preventDefault();
  el.click();
 });

 /* ---- Dedicated wishlist page (/pages/wishlist, sections/page-wishlist.liquid) ----
    That template has no server-rendered products (it can't — the saved
    list only exists in this browser's localStorage), so it just supplies
    an empty #wishlistGrid + #wishlistEmpty pair. Here we read the saved
    handles, fetch each product's real current data from Shopify's public
    /products/<handle>.js JSON endpoint, and build the same .pc card markup
    used everywhere else on the site (snippets/product-card.liquid) so the
    page looks native, not like a separate mini-app. Any handle whose fetch
    fails (product deleted/unpublished since it was saved) is dropped from
    both the page and the saved list itself, so a stale wishlist cleans
    itself up instead of showing a broken card forever. */
 function esc(s){return (s==null?'':String(s)).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})}
 function aed(cents){return 'AED '+Math.round((cents||0)/100)}
 function wishlistCardHTML(p,phone){
  var images=p.images||[],img=p.featured_image||images[0]||'';
  if(img&&img.indexOf('//')===0)img='https:'+img;
  var variants=p.variants||[],v=null;
  for(var i=0;i<variants.length;i++){if(variants[i].available){v=variants[i];break}}
  if(!v)v=variants[0]||{};
  var out=(p.available===false);
  var isAgm=(p.tags||[]).some(function(t){return /agm/i.test(t)});
  var multi=variants.length>1;
  var badge='';
  if(p.compare_at_price&&p.compare_at_price>p.price){
   var pct=Math.round((p.compare_at_price-p.price)*100/p.compare_at_price);
   badge='<span class="pc-badge pc-badge-dark">-'+pct+'%</span>';
  }else if(isAgm){
   badge='<span class="pc-badge pc-badge-blue">AGM</span>';
  }else if(multi){
   badge='<span class="pc-badge pc-badge-green">'+variants.length+' models</span>';
  }
  var oos=out?'<span class="pc-badge pc-badge-red" style="left:auto;right:10px">Out of Stock</span>':'';
  var priceHtml='<strong>'+(p.price_varies?'From ':'')+aed(p.price_min!=null?p.price_min:p.price)+'</strong>'+((p.compare_at_price&&p.compare_at_price>p.price)?'<del>'+aed(p.compare_at_price)+'</del>':'');
  var btn=multi
   ?'<a class="pc-btn" href="/products/'+p.handle+'">Choose Model</a>'
   :'<form action="/cart/add" method="post" data-ajax-cart style="display:contents"><input type="hidden" name="id" value="'+(v.id||'')+'"><input type="hidden" name="quantity" value="1"><button class="pc-btn" type="submit"'+(!v.available?' disabled':'')+'>'+(v.available?'Add to Cart':'Sold Out')+'</button></form>';
  return '<div class="pc" data-wishlist-card="'+esc(p.handle)+'">'
   +'<div class="pc-img"><img class="pc-photo" src="'+esc(img)+'" loading="lazy" alt="'+esc(p.title)+'">'
   +badge+oos
   +'<span class="pc-wishlist active" role="button" tabindex="0" aria-pressed="true" aria-label="Remove '+esc(p.title)+' from wishlist" data-wishlist-id="'+esc(p.handle)+'" style="color:#e53e3e'+(out?';top:48px':'')+'">♥</span>'
   +'<a class="pc-link" href="/products/'+p.handle+'" aria-label="'+esc(p.title)+'"></a>'
   +'</div>'
   +'<div class="pc-body">'
   +'<div class="pc-brand">'+esc(p.vendor)+'</div>'
   +'<div class="pc-name"><a href="/products/'+p.handle+'" style="color:inherit">'+esc(p.title)+'</a></div>'
   +'<div class="pc-price">'+priceHtml+'</div>'
   +'<div class="pc-fit">Fitted at your location in Dubai</div>'
   +'<div class="pc-btn-row">'+btn+'<a class="pc-call" href="tel:'+esc(phone)+'" aria-label="Call to order">📞</a></div>'
   +'</div></div>';
 }
 function renderWishlistPage(){
  var grid=document.getElementById('wishlistGrid');
  if(!grid)return;
  var empty=document.getElementById('wishlistEmpty');
  var phone=grid.getAttribute('data-phone')||'';
  var list=load();
  if(!list.length){if(empty)empty.hidden=false;return}
  Promise.all(list.map(function(handle){
   return fetch('/products/'+handle+'.js').then(function(r){return r.ok?r.json():null}).catch(function(){return null});
  })).then(function(products){
   var keep=[],html='';
   products.forEach(function(p,i){if(p){keep.push(list[i]);html+=wishlistCardHTML(p,phone)}});
   if(keep.length!==list.length)persist(keep); /* drop stale/deleted handles */
   grid.innerHTML=html;
   if(!keep.length&&empty)empty.hidden=false;
   updateCount();
  });
 }
 renderWishlistPage();
})();
})();
